// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__shhir","question":"styles_question__2unnF","description":"styles_description__1Bpev"};